export default __webpack_public_path__ + "static/media/qrcode-whatsapp.0c0acda6.svg";